<style>
</style>
<template>
<div v-if="hasCustomer">
  <v-dialog v-model="value" max-width="400">
    <v-card>
      <v-card-title class="headline">{{ $t('Upozornění') }}</v-card-title>
      <v-card-text>{{ $t('Delší dobu jste neprovedli v rámci aplikace žádnou činnost. Za okamžik budete odhlášeni.') }}</v-card-text>
    </v-card>
  </v-dialog>
</div>
</template>
<script>
import CustomerMixin from '@/mixins/customer-mixin.js'

export default {
  mixins: [CustomerMixin],
  props: {
    value: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      timer: ''
    }
  },
  watch: {
    value() {
      if (this.value === true) {
        this.timer = setInterval(this.signOut, 30000)
      } else {
        clearInterval(this.timer)
      }
    }
  },
  methods: {
    signOut() {
      clearInterval(this.timer)
      this.$router.push({
        name: 'logout'
      }).catch(console.log)
    }
  },
  beforeDestroy() {
    clearInterval(this.timer)
  }
}
</script>
